// extracted by mini-css-extract-plugin
export default {"stopModalScroll":"_7708b924","spinnerWrapper":"_c8e36254"};